import React from 'react';

import i18next from 'i18next';

import { Tooltip } from '@commons/utils/styledLibraryComponents';

import { ProgressBarContainer, ProgressBar, ProgressText, InfoIcon } from './styledComponents';

const CreditsProgressBar = ({ dailyUsage = 0 }) => {
  const usedCredits = Math.min(Math.floor(dailyUsage), 100);

  return (
    <ProgressBarContainer>
      <ProgressBar usedCredits={usedCredits}>
        <div className="progress-fill" />
      </ProgressBar>
      <ProgressText>
        {i18next.t('AGENT.AGENT.CREDITS_USED', { percentage: usedCredits })}
        <Tooltip
          renderTooltipTrigger={() => <InfoIcon>ⓘ</InfoIcon>}
          text={i18next.t('AGENT.AGENT.CREDITS_RESET_INFO')}
        />
      </ProgressText>
    </ProgressBarContainer>
  );
};

export default CreditsProgressBar;
